import { LinkDictionary } from 'capcod-api';

export class WorkflowDictionary extends LinkDictionary {
  links: { type: string; link?: string | undefined }[] = [];
}
